export const LOGIC = 'Logic'
export const WORDS = 'Words'

export type PuzzleMainType = typeof LOGIC | typeof WORDS
